import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../core/navbar.service';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.css']
})
export class TopComponent {
  isHandset$: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset)
  title = 'Bayou Lacombe Museum'
  constructor(public nav: NavbarService,private breakpointObserver: BreakpointObserver) { }

 

}
